export type RouteKeys =
  | 'HOME'
  | 'PORTAL'
  | 'MARKET'
  | 'ABOUT'
  | 'DAILY_DEALS'
  | 'LOOTBOX'
  | 'TOP_OFFERS'
  | 'LEADERS'
  | 'REFERRALS'
  | 'PROFILE'
  | 'TRADES'
  | 'LANDLORD_GO'
  | 'WHITEPAPER'
  | 'ASSETS'
  | 'LIST_FOR_SALE'
  | 'REDEEM'
  | 'MEDIA'
  | 'CONTACT'
  | 'GAMES'
  | 'PERIODICAL_STAKING'
  | 'DEALS'
  | 'PROMOTIONS'
  | 'STORE'
  | 'PACKAGE'
  | 'EVENTS'
  | 'TRADING_EVENT'
  | 'WORLD_NFT'
  | 'NFT_SWAP'
  | 'REFERRAL'
  | 'AMA'
  | 'STAKING_OUTDATED'
  | 'TASK_BASED'
  | 'INFORMATIONAL'
  | 'DASHBOARD'
  | 'BID2EARN'
  | 'BURN'
  | 'VIP';

export type ProfileRouteKeys = 'COLLECTED';

export type QueryParamKeys = 'SECTION';

export const ROUTES: Record<RouteKeys, string> = {
  HOME: '/home',
  PORTAL: '/home/portal',
  MARKET: '/home/market',
  ABOUT: '/home/about',
  DAILY_DEALS: '/home/daily-deals',
  LOOTBOX: '/home/lootbox',
  TOP_OFFERS: '/home/top-offers',
  LEADERS: '/home/leaders',
  REFERRALS: '/home/referrals',
  PROFILE: '/home/profile',
  TRADES: '/home/trades',
  LANDLORD_GO: '/home/landlordgo',
  WHITEPAPER: '/home/white-paper',
  ASSETS: '/home/assets',
  LIST_FOR_SALE: '/home/list-for-sale',
  REDEEM: '/home/redeem',
  MEDIA: '/media',
  CONTACT: '/contact',
  GAMES: '/games',
  PERIODICAL_STAKING: '/staking',
  DEALS: '/home/deals',
  PROMOTIONS: '/news',
  STORE: '/store',
  PACKAGE: '/package',
  EVENTS: '/events',
  TRADING_EVENT: '/events/trading',
  WORLD_NFT: '/world-nft',
  NFT_SWAP: '/nft-swap',
  REFERRAL: '/events/referral',
  AMA: '/events/ama',
  STAKING_OUTDATED: '/staking-outdated',
  TASK_BASED: '/task-based',
  INFORMATIONAL: '/events/informational',
DASHBOARD: '/home/dashboard',
  BID2EARN: '/home/bid2earn',
  BURN: '/home/burn',
  VIP: '/vip',
};

export const PROFILE_ROUTES: Record<ProfileRouteKeys, string> = {
  COLLECTED: `${ROUTES.PROFILE}/collected`,
};

export const QUERY_PARAMS: Record<QueryParamKeys, string> = {
  SECTION: 'section',
};

export const SECTION_VALUES = {
  DIGITAL_ASSET_PACKAGES: 'digital-asset-packages',
} as const;
